import { Box } from '@material-ui/core'
import styled, { css } from 'styled-components'

import { Grid } from '../../components/Base/Base'
import { InlineSpinner } from '../../components/Spinner'
import { Text } from '../../components/Text/Text'
import { Handler } from '../../helpers/typeHelper'
import { useDocuments } from '../../hooks/query/useDocuments'
import {
  ChildrenDocument,
  ChildrenDocumentAttachment,
  ChildrenDocumentMissing,
  FolderName,
} from '../../models/document'
import { bgGray, informationL1, lightGray1 } from '../../theme/colors'
import { DocumentRows } from './DocumentRows'

interface DocumentListProps {
  recordId: string
  folder: FolderName
  displayFolders: FolderName[]
  onDocumentOpen?: (
    document: ChildrenDocument | ChildrenDocumentMissing,
    attachments?: ChildrenDocumentAttachment[]
  ) => React.ReactNode
  renderDocumentAction?: (
    document: ChildrenDocument | ChildrenDocumentMissing,
    attachments?: ChildrenDocumentAttachment[],
    refetchDocuments?: () => Promise<any>
  ) => React.ReactNode
}

export function DocumentList({
  recordId,
  folder,
  displayFolders,
  onDocumentOpen,
  renderDocumentAction,
}: DocumentListProps) {
  const { documents, isLoading, refetch } = useDocuments(recordId, folder)

  if (!documents || isLoading) {
    return <InlineSpinner mt={5} mb={5} />
  }

  return (
    <>
      <DocumentListGrid>
        <Text variant="label2" fontColor={lightGray1}>
          Document
        </Text>
        <Text variant="label2" fontColor={lightGray1}>
          Status
        </Text>
        <Text variant="label2" fontColor={lightGray1}>
          Effective
        </Text>
        <Text variant="label2" fontColor={lightGray1}>
          Expiration
        </Text>
        <Text variant="label2" fontColor={lightGray1}>
          Category
        </Text>
        <div></div>
      </DocumentListGrid>
      <Box mt={3} />
      <DocumentRows
        folder={documents}
        refetchDocuments={() => refetch()}
        displayFolders={displayFolders}
        onDocumentOpen={onDocumentOpen}
        renderDocumentAction={renderDocumentAction}
      />
    </>
  )
}

export function DocumentListGrid({
  children,
  className,
  isItem,
  isSmall,
  onClick,
}: {
  children: React.ReactNode
  className?: string
  isItem?: boolean
  isSmall?: boolean
  onClick?: Handler
}) {
  const columns = '335px 130px 110px 110px 140px auto'

  if (isItem) {
    return (
      <HoveredGrid columns={columns} gap="15px" className={className} onClick={onClick} $isSmall={isSmall}>
        {children}
      </HoveredGrid>
    )
  }

  return (
    <Grid columns={columns} gap="15px" className={className}>
      {children}
    </Grid>
  )
}

const HoveredGrid = styled(Grid)<{ onClick?: Handler; $isSmall?: boolean }>`
  position: relative;
  margin: 0 -24px;
  padding: 25px 24px 17px;

  ${(p) =>
    p.onClick &&
    css`
      cursor: pointer;

      &:hover {
        background-color: ${informationL1};

        .actions > * {
          visibility: visible;
        }
      }
    `}

  ${(p) =>
    p.$isSmall &&
    css`
      padding-top: 15px;
      padding-bottom: 5px;
    `}

  &::before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    border-top: 2px solid ${bgGray};
  }
`
